import { render, staticRenderFns } from "./vFormVIDEO.vue?vue&type=template&id=161f78fe&scoped=true&"
import script from "./vFormVIDEO.vue?vue&type=script&lang=js&"
export * from "./vFormVIDEO.vue?vue&type=script&lang=js&"
import style0 from "./vFormVIDEO.vue?vue&type=style&index=0&id=161f78fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f78fe",
  null
  
)

export default component.exports